import { useDispatch } from "react-redux";
import { openSideDrawer } from "../../../../../utils/permissionSlice";
import { HiOutlinePencil } from "react-icons/hi";
import LockIcon from "@mui/icons-material/Lock";
import { checkAccessPermission } from "../../../../../utils/utilityFunctions/localServices";
import HighlightedParagraph from "../../../../UniversalComponents/HighlightedParagraph";

export function GroupRow({ groups, groupNameSearch }) {
  const dispatch = useDispatch();

  const handleEditPermission = (group) => {
    dispatch(openSideDrawer({ key: "EDIT_PERMISSION", data: group }));
  };

  const handleAddMember = (group) => {
    console.log("haresh group", group);
    dispatch(openSideDrawer({ key: "ADD_MEMBER", data: group }));
  };

  const handleOpenAbout = (group) => {
    dispatch(openSideDrawer({ key: "GROUP_ABOUT", data: group }));
  };

  // const groups = [
  //   {
  //     name: "Accounting",
  //     members: 1,
  //     isAdmin: true,
  //     views: ["Default"],
  //   },
  //   {
  //     name: "Auditing",
  //     members: 24,
  //     isAdmin: false,
  //     views: ["View 1", "View 2", "View 3", "View 4", "View 5"],
  //   },
  //   {
  //     name: "Finance Team",
  //     members: 24,
  //     isAdmin: false,
  //     views: ["Default"],
  //   },
  //   {
  //     name: "Finance Team",
  //     members: 0,
  //     isAdmin: false,
  //     views: ["Default"],
  //   },
  // ];

  return (
    <div className="overflow-x-auto w-full">
      <div className="w-full rounded border border-gray-200">
        <div className="grid grid-cols-3 text-sm font-medium px-5 py-3 border-b bg-primary-active">
          <div>Group Name</div>
          <div>Tracking Views (CRM)</div>
          <div className="text-center">Action</div>
        </div>

        {groups
          ?.filter((group) => group?.group_name?.toLowerCase()?.includes(groupNameSearch?.toLowerCase()))
          .map((group, index) => (
            <div
              key={index}
              className={`grid grid-cols-3 items-center px-5 py-2 hover:bg-primary-hover rounded border-b border-gray-200`}
            >
              {/* Group Info */}
              <div>
                <div
                  onClick={() => handleOpenAbout(group)}
                  className="flex w-fit text-primary cursor-pointer items-center gap-1 font-medium"
                >
                  <span>
                    <HighlightedParagraph paragraph={group?.group_name} searchTerm={groupNameSearch} />
                  </span>
                  {group?.is_locked === 1 && (
                    <span
                      onClick={() => handleEditPermission(group)}
                      className="flex items-center text-xs gap-1 p-0.5 bg-primary-20 text-gray-700 rounded"
                    >
                      <LockIcon sx={{ fontSize: "16px" }} />
                    </span>
                  )}
                </div>
                <div
                  onClick={() => handleAddMember(group)}
                  className="text-xs w-fit text-gray-500 hover:underline cursor-pointer mt-1"
                >
                  {group?.total_members} Members
                </div>
              </div>

              {/* Dropdown */}
              <div>
                {/* <SelectComponent
                options={group?.tracking_views?.map((data) => ({ label: data?.name, value: data?.id })) || []}
                value={
                  group?.tracking_views
                    ?.filter((data) => data?.is_enabled === 1)
                    ?.map((data) => ({ label: data?.name, value: data?.id })) || []
                }
                multiSelect
                disabled={true}
                onChange={() => { }}
              /> */}
                <div className="flex gap-2">
                  {group?.tracking_views
                    ?.filter((data) => data?.is_enabled === 1)
                    ?.slice(0, 3)
                    .map((item, index) => (
                      <p
                        key={index}
                        className="px-2 py-1 border-[1px] flex items-center border-gray-200 rounded-lg w-fit text-gray-600 cursor-pointer hover:bg-gray-200 text-sm"
                        onClick={() => handleOpenAbout(group)}
                      >
                        {item?.name}
                      </p>
                    ))}

                  {group?.tracking_views?.filter((data) => data?.is_enabled === 1)?.length > 3 && (
                    <p
                      onClick={() => handleOpenAbout(group)}
                      className="px-2 py-1 border-[1px] border-gray-200 rounded-lg w-fit text-gray-600 cursor-pointer hover:bg-gray-200"
                    >
                      + {group?.tracking_views?.filter((data) => data?.is_enabled === 1)?.length - 3}
                    </p>
                  )}
                </div>
              </div>

              {/* Actions */}
              <div className="flex justify-end items-center gap-2">
                {checkAccessPermission("Add & Manage Groups & Permission") && (
                  <>
                    <button
                      opacity={group?.is_locked === 1 ? 0.5 : 1}
                      onClick={() => handleAddMember(group)}
                      className={`text-blue-600 text-sm py-2 px-4 hover:bg-gray-200 rounded-lg ${!checkAccessPermission("Add & Manage Groups & Permission") && "cursor-not-allowed"}`}
                      disabled={!checkAccessPermission("Add & Manage Groups & Permission")}
                    >
                      + Add Member
                    </button>
                    <button
                      onClick={() => handleEditPermission(group)}
                      className={`text-blue-600 ${!checkAccessPermission("Add & Manage Groups & Permission") && "cursor-not-allowed"} text-sm py-2 px-4 hover:bg-gray-200 rounded-lg flex gap-1 items-center opacity-${group?.is_locked === 1 ? "50" : "100"}`}
                      disabled={!checkAccessPermission("Add & Manage Groups & Permission")}
                    >
                      <HiOutlinePencil size={14} />
                      Edit Permission
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}

        {groups?.filter((group) => group?.group_name?.toLowerCase()?.includes(groupNameSearch?.toLowerCase()))
          ?.length === 0 && <div className="px-5 py-3">No Groups Found</div>}
      </div>
    </div>
  );
}
